__webpack_require__.p = "https://purple-mushroom-01ec9ab03.2.azurestaticapps.net/";